const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGrowth(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 501.333 501.333",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 381.867,
    y: 171.733,
    style: {
      fill: "#F16D6E"
    },
    width: 119.467,
    height: 329.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.933,
    y: 275.2,
    style: {
      fill: "#60C3AB"
    },
    width: 119.467,
    height: 226.133
  }), /*#__PURE__*/React.createElement("rect", {
    y: 355.2,
    style: {
      fill: "#637888"
    },
    width: 119.467,
    height: 146.133
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FEC656"
    },
    points: "392.533,100.267 51.2,256 21.333,188.8 362.667,33.067  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FEC656"
    },
    points: "333.867,0 397.867,142.933 480,19.2  "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrowth);
export default __webpack_public_path__ + "static/media/growth.788d249d23cc74f4d58175e1770789d8.svg";
export { ForwardRef as ReactComponent };